import ResultsProductsAndInventions from './resultsProductsAndInventions.js';
export default ResultsProductsAndInventions;
